<h3 class="title configurator-title">{{ 'closet-doors.door-configuration.title' | translate }}</h3>

<ng-closet-doors-standard-door-recess></ng-closet-doors-standard-door-recess>

@if (areDimensionsValid) {
  <section class="config-container shadow mt-3">
    <h4 class="title configurator-subtitle">{{ 'closet-doors.door-configuration.panel-configuration' | translate }}</h4>

    <ng-closet-doors-standard-door-plinth></ng-closet-doors-standard-door-plinth>

    <ng-closet-doors-standard-door-number></ng-closet-doors-standard-door-number>
  </section>
}
